import { useQuery } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { QueryFunction } from '@frontend/api';

import { DigiQuoteSettings } from './types';

export type UseDigiQuoteSettingsParams = {
  groupId: string;
};

export type DigiQuoteSettingsKey = readonly [
  'suppliers',
  string,
  'digiQuoteSettings',
];

export const getDigiQuoteSettingsKey = (
  params: UseDigiQuoteSettingsParams,
): DigiQuoteSettingsKey =>
  ['suppliers', params.groupId, 'digiQuoteSettings'] as const;

export const useDigiQuoteSettings: QueryFunction<
  DigiQuoteSettings,
  [UseDigiQuoteSettingsParams],
  DigiQuoteSettingsKey
> = (params, { requestOptions, queryOptions } = {}) => {
  const queryKey = getDigiQuoteSettingsKey(params);
  const request = useRequest(requestOptions);

  return useQuery({
    ...queryOptions,
    queryKey,
    queryFn: ({ signal }) =>
      request(`/suppliers/${params.groupId}/digi_quote_settings`, {
        init: {
          method: 'GET',
          signal,
        },
      }),
  });
};
